module.exports = __webpack_public_path__ + "static/tr1-f84fa368180356d35c8176e408167777.jpg";